<pageheader [entity]="headerEntity"></pageheader>
<div *ngIf="listView" class="top-btns">
  <div class="table-outer">
    <grid [entities]="role" [actionExclude]="['feedback','column']" [checkboxCol]="true" [entityColumns]="entityColumns" [selectionField]="'Role_Id'"
      [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add '" [downloadEntityCaption]="'Download '"
      (addEntity)="addRole($event)" (editEntity)="editRole($event)" (refreshEntities)="refreshRole($event)"
      (deleteEntity)="deleteRole($event)" [pageSize]="10"></grid>
  </div>
</div>
<div *ngIf="!listView">
  <div class="report">
    <nav class="navbar-expand-md navbar-white navbar-form bg-light mt-2">
      <ul class="navbar-nav justify-content-end">
        <li class="nav-item form-caption-nav">
          <a class="nav-link">{{ formCaption }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="clearRole()"><i class="bi bi-slash-circle"></i>Clear</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="revertChanges()"><i class="bi bi-arrow-clockwise"></i>Revert
            Changes</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="gotoBack()"><i class="bi bi-arrow-left-circle"></i>Go Back</a>
        </li>
      </ul>
    </nav>
    <div class="form-body">
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <textbox [caption]="'Role Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
              [fieldName]="'Role_Name'" [(ngModel)]="entity.Role_Name" ngDefaultControl></textbox>
          </div>
        </div>

      </div>
      <div class="mt-3">
        <btn [label]="'Save'" (click)="saveRole($event)" [class]="'btn-1 btn-11'" [type]="'button'">
        </btn>
      </div>
    </div>
  </div>
</div>